import { render, staticRenderFns } from "./ComplaintsView.vue?vue&type=template&id=46f3d8ce&scoped=true&"
import script from "./ComplaintsView.vue?vue&type=script&lang=js&"
export * from "./ComplaintsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3d8ce",
  null
  
)

export default component.exports